/*=========================================================================================
  File Name: moduleCategoryMutations.js
  Description: Category Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_VISIT_POINT(state, item) {
		state.visitPoints.unshift(item);
	},
	SET_VISIT_POINTS(state, items) {
		state.visitPoints = [...items];
	},
	UPDATE_VISIT_POINT(state, visitPoint) {
		const visitPointIndex = state.visitPoints.findIndex((p) => p.id === visitPoint.id);
		if (visitPointIndex !== -1) {
			Object.assign(state.visitPoints[visitPointIndex], visitPoint);
		}
	},
	REMOVE_ALL_VISIT_POINT(state) {
		state.visitPoints = [];
	},
	REMOVE_VISIT_POINT(state, itemId) {
		const ItemIndex = state.visitPoints.findIndex((p) => p.id === itemId);
		state.visitPoints.splice(ItemIndex, 1);
	},
	SET_ASSIGNED_VISIT_POINT(state, items) {
		let arrayNew = state.assignedVisitPoints.concat(
			items.filter((element) => state.assignedVisitPoints.find((e) => e.id === element.id) === undefined)
		);
		state.assignedVisitPoints = arrayNew;
	},
	REMOVE_ASSIGNED_VISIT_POINT(state, itemId) {
		const ItemIndex = state.assignedVisitPoints.findIndex((p) => p.id === itemId);
		state.assignedVisitPoints.splice(ItemIndex, 1);
	},
	REMOVE_ALL_ASSIGNED_VISIT_POINT(state) {
		state.assignedVisitPoints = [];
	},
	ADD_VISIT_POINT_CHECKED(state, item) {
		const itemIndex = state.checkedVisitPoits.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedVisitPoits.push(item);
		}
	},
	SET_VISIT_POINT_CHECKED(state, visitPoints) {
		state.checkedVisitPoits = visitPoints;
	},
	REMOVE_VISIT_POINT_CHECKED(state, item) {
		const itemIndex = state.checkedVisitPoits.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedVisitPoits.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_VISIT_POINT_CHECKED(state) {
		state.checkedVisitPoits = [];
	},
	SELECTED_VISIT_POINT(state, visitPoint) {
		if (visitPoint) {
			state.currentVisitPointId = visitPoint.id !== undefined ? visitPoint.id : 0;
			state.currentVisitPoint = visitPoint;
		} else {
			state.currentVisitPoint = {};
			state.currentVisitPointId = 0;
		}
	},
	ADD_VISIT_POINT_PICKUP(state, item) {
		state.visitPointsPickup.unshift(item);
	},
	SET_VISIT_POINTS_PICKUP(state, items) {
		state.visitPointsPickup = [...items];
	},
	UPDATE_VISIT_POINT_PICKUP(state, visitPoint) {
		const visitPointIndex = state.visitPointsPickup.findIndex((p) => p.id === visitPoint.id);
		if (visitPointIndex !== -1) {
			Object.assign(state.visitPointsPickup[visitPointIndex], visitPoint);
		}
	},
	REMOVE_ALL_VISIT_POINT_PICKUP(state) {
		state.visitPointsPickup = [];
	},
	REMOVE_VISIT_POINT_PICKUP(state, itemId) {
		const ItemIndex = state.visitPointsPickup.findIndex((p) => p.id === itemId);
		state.visitPointsPickup.splice(ItemIndex, 1);
	},
	ADD_VISIT_POINT_CHECKED_PICKUP(state, item) {
		const itemIndex = state.checkedVisitPoitsPickup.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedVisitPoitsPickup.push(item);
		}
	},
	SET_VISIT_POINT_CHECKED_PICKUP(state, items) {
		state.checkedVisitPoitsPickup = [...items];
	},
	REMOVE_VISIT_POINT_CHECKED_PICKUP(state, item) {
		const itemIndex = state.checkedVisitPoitsPickup.findIndex((p) => p.identification === item.identification);
		if (itemIndex >= 0) {
			state.checkedVisitPoitsPickup.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_VISIT_POINT_CHECKED_PICKUP(state) {
		state.checkedVisitPoitsPickup = [];
	},
	ADD_VISIT_POINT_DELIVERY(state, item) {
		state.visitPointsDelivery.unshift(item);
	},
	SET_VISIT_POINTS_DELIVERY(state, items) {
		state.visitPointsDelivery = [...items];
	},
	UPDATE_VISIT_POINT_DELIVERY(state, visitPoint) {
		const visitPointIndex = state.visitPointsDelivery.findIndex((p) => p.id === visitPoint.id);
		if (visitPointIndex !== -1) {
			Object.assign(state.visitPointsDelivery[visitPointIndex], visitPoint);
		}
	},
	REMOVE_ALL_VISIT_POINT_DELIVERY(state) {
		state.visitPointsDelivery = [];
	},
	REMOVE_VISIT_POINT_DELIVERY(state, itemId) {
		const ItemIndex = state.visitPointsDelivery.findIndex((p) => p.id === itemId);
		state.visitPointsDelivery.splice(ItemIndex, 1);
	},
	ADD_VISIT_POINT_CHECKED_DELIVERY(state, item) {
		const itemIndex = state.checkedVisitPoitsDelivery.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedVisitPoitsDelivery.push(item);
		}
	},
	SET_VISIT_POINT_CHECKED_DELIVERY(state, items) {
		state.checkedVisitPoitsDelivery = [...items];
	},
	REMOVE_VISIT_POINT_CHECKED_DELIVERY(state, item) {
		const itemIndex = state.checkedVisitPoitsDelivery.findIndex((p) => p.identification === item.identification);
		if (itemIndex >= 0) {
			state.checkedVisitPoitsDelivery.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_VISIT_POINT_CHECKED_DELIVERY(state) {
		state.checkedVisitPoitsDelivery = [];
	},
	SET_VISIT_POINTS_DATARUTAS(state, items) {
		state.visitPointsDatarutas = [...items];
	},
	UPDATE_VISIT_POINT_DATARUTAS(state, visitPoint) {
		const visitPointIndex = state.visitPointsDatarutas.findIndex((p) => p.id === visitPoint.id);
		if (visitPointIndex !== -1) {
			Object.assign(state.visitPointsDatarutas[visitPointIndex], visitPoint);
		}
	},
	REMOVE_ALL_VISIT_POINT_DATARUTAS(state) {
		state.visitPointsDatarutas = [];
	},
	REMOVE_VISIT_POINT_DATARUTAS(state, itemId) {
		const ItemIndex = state.visitPointsDatarutas.findIndex((p) => p.id === itemId);
		state.visitPoints.splice(ItemIndex, 1);
	},
	ADD_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS(state, item) {
		const itemIndex = state.checkedVisitPoitsDeliveryDatarutas.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedVisitPoitsDeliveryDatarutas.push(item);
		}
	},
	SET_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS(state, items) {
		state.checkedVisitPoitsDeliveryDatarutas = [...items];
	},
	REMOVE_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS(state, item) {
		const itemIndex = state.checkedVisitPoitsDeliveryDatarutas.findIndex(
			(p) => p.identification === item.identification
		);
		if (itemIndex >= 0) {
			state.checkedVisitPoitsDeliveryDatarutas.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS(state) {
		state.checkedVisitPoitsDeliveryDatarutas = [];
	},
	ADD_VISIT_POINT_CHECKED_PICKUP_DATARUTAS(state, item) {
		const itemIndex = state.checkedVisitPoitsPickupDatarutas.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedVisitPoitsPickupDatarutas.push(item);
		}
	},
	SET_VISIT_POINT_CHECKED_PICKUP_DATARUTAS(state, items) {
		state.checkedVisitPoitsPickupDatarutas = [...items];
	},
	REMOVE_VISIT_POINT_CHECKED_PICKUP_DATARUTAS(state, item) {
		const itemIndex = state.checkedVisitPoitsPickupDatarutas.findIndex(
			(p) => p.identification === item.identification
		);
		if (itemIndex >= 0) {
			state.checkedVisitPoitsPickupDatarutas.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_VISIT_POINT_CHECKED_PICKUP_DATARUTAS(state) {
		state.checkedVisitPoitsPickupDatarutas = [];
	},
	SET_UPLOAD_FILE_VISIT_POINTS_OPTIMIZATION(state, visitPoints) {
		state.uploadFileVisitPointsOptimization.push(visitPoints);
	},
	REMOVE_UPLOAD_FILE_VISIT_POINT_OPTIMIZATION(state, item) {
		const itemIndex = state.uploadFileVisitPointsOptimization.findIndex((p) => p.bucket_path === item.bucket_path);
		if (itemIndex >= 0) {
			state.uploadFileVisitPointsOptimization.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_UPLOAD_FILE_VISIT_POINTS_OPTIMIZATION(state) {
		state.uploadFileVisitPointsOptimization = [];
	},
	ADD_UPLOAD_FILE_VISIT_POINT_CHECKED_DELIVERY(state, item) {
		state.checkedUploadFileVisitPoitsDelivery.push(item);
	},
	REMOVE_UPLOAD_FILE_VISIT_POINT_CHECKED_DELIVERY(state, item) {
		const itemIndex = state.checkedUploadFileVisitPoitsDelivery.findIndex(
			(p) => p.bucket_path === item.bucket_path
		);
		if (itemIndex >= 0) {
			state.checkedUploadFileVisitPoitsDelivery.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_UPLOAD_FILE_VISIT_POINT_CHECKED_DELIVERY(state) {
		state.checkedUploadFileVisitPoitsDelivery = [];
	},
	ADD_UPLOAD_FILE_VISIT_POINT_CHECKED_PICKUP(state, item) {
		state.checkedUploadFileVisitPoitsPickup.push(item);
	},
	REMOVE_UPLOAD_FILE_VISIT_POINT_CHECKED_PICKUP(state, item) {
		const itemIndex = state.checkedUploadFileVisitPoitsPickup.findIndex((p) => p.bucket_path === item.bucket_path);
		if (itemIndex >= 0) {
			state.checkedUploadFileVisitPoitsPickup.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_UPLOAD_FILE_VISIT_POINT_CHECKED_PICKUP(state) {
		state.checkedUploadFileVisitPoitsPickup = [];
	},
	ADD_VISIT_POINT_CHECKED_DATARUTAS(state, item) {
		const itemIndex = state.checkedVisitPoitsDatarutas.findIndex((p) => p.identification === item.identification);
		if (itemIndex === -1) {
			state.checkedVisitPoitsDatarutas.push(item);
		}
	},
	REMOVE_VISIT_POINT_CHECKED_DATARUTAS(state, item) {
		const itemIndex = state.checkedVisitPoitsDatarutas.findIndex((p) => p.identification === item.identification);
		if (itemIndex >= 0) {
			state.checkedVisitPoitsDatarutas.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_VISIT_POINT_CHECKED_DATARUTAS(state) {
		state.checkedVisitPoitsDatarutas = [];
	},
};
